module.exports = __webpack_public_path__ + "static/img/seamless-money-background-vector.bf48106.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/seamless-money-background-vector.jpg
// module id = 2KlS
// module chunks = 1